/**
 * MailCta — a mailto call-to-action in the brutalist button style.
 *
 * Replaces the FormCarry-backed NewsletterForm and RsvpForm (removed
 * 2026-09-27 when the FormCarry account was shut down). A signup or RSVP is
 * now an email to hello@oakcliff.tech, which SES forwards to the operator's
 * inbox (see infra/MAIL.md). No third-party form backend, no secrets, no
 * submission log to export.
 *
 * The subject and body are prefilled so the email needs nothing but "send".
 */

import React from 'react';
import styles from './MailCta.module.css';

export const CONTACT_EMAIL = 'hello@oakcliff.tech';

interface MailCtaProps {
  /** Button text, e.g. "GET ON THE LIST" */
  label: string;
  /** Prefilled subject line */
  subject: string;
  /** Prefilled body (plain text; newlines allowed) */
  body?: string;
  /** Mono hint under the button */
  hint?: string;
}

export function mailtoHref(subject: string, body?: string): string {
  const params = new URLSearchParams({ subject });
  if (body) params.set('body', body);
  // URLSearchParams encodes spaces as "+", which mail clients read literally.
  return `mailto:${CONTACT_EMAIL}?${params.toString().replace(/\+/g, '%20')}`;
}

export default function MailCta({ label, subject, body, hint }: MailCtaProps): React.ReactElement {
  return (
    <div className={styles.cta}>
      <a className={styles.button} href={mailtoHref(subject, body)}>
        {label}
      </a>
      <p className={styles.address}>
        Opens an email to <b>{CONTACT_EMAIL}</b>
      </p>
      {hint && <p className={styles.hint}>{hint}</p>}
    </div>
  );
}
